import React from 'react';
import HomePageRouter from './HomePage/HomePageRouter';
import './App.css';

function App() {
  return (
    <div className="App">
      <HomePageRouter />
    </div>
  );
}

export default App;
